import { N62 } from "./SalesPerfSummary/N62"
import { N34 } from "./ActualTarget/N34"
import { N33 } from "./ActualLastYear/N33"
import { N68 } from "./SalesPerformanceByDM/N68"
import { N68_12 } from "./DistrictComparativeMonthly/N68_12"
import { N32 } from "./SalesPeformancePMR/N32"
import { N70_02 } from "../../executiveregion/CustomerGroupProduct/ProductSales/N70_02"
import { N68_Top10 } from "./SalesPerformanceByDM/N68_Top10"
import { N32_02 } from "./SalesPeformancePMR/N32_02"
import { N68_21 } from "./SalesPerformancePerArea/N68_21"
import { N76 } from "./QuarterlySalesVsTargetCompleted/N76"
import { N77 } from "./QuarterlySalesVsTargetCompletedbyConfig/N77"



export const ComparativeSalesPerformance = {
  "sections": [
    N62,
    N68_Top10,
    N70_02,
    N77,
    N76,
    N34,
    N33,
    N68,    
    N68_12,
    N32,
    N32_02,
    N68_21,
  ]
}